<template>
  <action :onAction="editUsernameAction">
    <template v-slot:icon><v-icon>account_circle</v-icon></template>
    <template v-slot:tooltip><span>Change the User's Username.</span></template>
    <template v-slot:label><span>Change Username</span></template>
  </action>
</template>

<script>
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Action from '@/components/action/Action.vue';

@Component({
  components: {
    Action,
  },
})
export default class EditUsernameAction extends Action {
  @Prop(Function) displayEditUsernameDialog;
  @Prop(Object) user;

  editUsernameAction() {
    this.displayEditUsernameDialog(this.user);
  }
}
</script>
